<template>
	<div class="full-width">
		<h5 class="headline mb-5">{{title}}</h5>

		<v-layout wrap>
			<v-flex xs12 md6 lg4>
				<v-text-field
					label="Enter UserId"
					prepend-icon="person"
					v-model="userId"
					@keyup.enter="grabRetailer"
				></v-text-field>
			</v-flex>
			<v-flex class="px-3">
				<v-btn fab :color="themeInputColor" class="white--text" @click="grabRetailer">
					<v-icon>search</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>

		<v-layout v-if="grabRetailerData" class="full-width">
			<advance-user-view
				:user="grabRetailerData"
				:userMod="grabRetailerData"
				:themeInputColor="themeInputColor"
				:allProps="allProps"
			/>
		</v-layout>

		<div v-if="grabRetailerData">
			<transaction-history :themeInputColor="themeInputColor" :userId="userId" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

import AdvanceUserView from "@/components/Advance-user-view";
import TransactionHistory from "@/components/TransactionHistory";

import {
	FETCH_RETAILER_DATA,
	FETCH_TRANSACTION_HISTORY,
	RESET_GRAB_RETAILER
} from "@/store/action-types";

export default {
	name: "GrabRetailer",
	props: ["title", "themeInputColor"],
	data() {
		return {
			userId: null,
			grabRetailerLoading: false,
			fetchTransactionHistoryLoading: false,
			allProps: [
				{ name: "language", text: "Language", icon: "language" },
				{ name: "location", text: "City", icon: "place" },
				{
					name: "createdOn",
					text: "Signed Up On",
					icon: "event_available"
				},
				{
					name: "lastAppOpened",
					text: "Last Opened On",
					icon: "event"
				},
				{
					name: "assignedBroker",
					text: "Assigned Broker",
					icon: "cloud"
				},
				{
					name: "phoneModel",
					text: "Phone Model",
					icon: "phone_android"
				},
				{
					name: "appVersion",
					text: "App Version",
					icon: "phonelink_setup"
				},
				{
					name: "state",
					text: "State",
					icon: "phonelink_setup"
				},
				{
					name: "city",
					text: "City",
					icon: "phonelink_setup"
				},
				{
					name: "micro_market",
					text: "Micro_market",
					icon: "phonelink_setup"
				},
				{
					name: "referralCode",
					text: "Referral Code",
					icon: "phone_android"
				},
				{
					name: "installCount",
					text: "Installs",
					icon: "phonelink_setup"
				}
			],
			transactionProps: [
				{ text: "User ID", key: "userId", copy_allowed: true },
				{ text: "Transaction time", key: "time" },
				{ text: "Amount", key: "amount" },
				{ text: "Remarks", key: "remarks" },
				{ text: "Status", key: "status", template_type: 2 },
				{ text: "Transaction ID", key: "transactionId" },
				{ text: "Account Info", key: "accInfo" }
			]
		};
	},
	components: {
		"advance-user-view": AdvanceUserView,
		"transaction-history": TransactionHistory
	},
	mounted() {
		// this.userId = "53066038";
		this.$store.dispatch(RESET_GRAB_RETAILER.dispatch);
	},
	computed: {
		...mapState({
			grabRetailerData: state => state.retail.grabRetailerData,
			transactionHistory: state =>
				state.retail.grabRetailerTransactionHistory,
			transactionHistoryOffset: state =>
				state.retail.grabRetailerTransactionHistoryOffset
		})
	},
	methods: {
		grabRetailer() {
			if (!this.grabRetailerLoading) {
				this.grabRetailerLoading = true;
				this.$store
					.dispatch(FETCH_RETAILER_DATA.dispatch, {
						userId: this.userId,
						dataKey: "grabRetailerData"
					})
					.catch(() => {})
					.then(() => {
						this.grabRetailerLoading = false;
					});
			}
		},
		fetchTransactionHistory(type) {
			if (!this.fetchTransactionHistoryLoading) {
				this.fetchTransactionHistoryLoading = true;
				this.$store
					.dispatch(FETCH_TRANSACTION_HISTORY.dispatch, {
						userId: this.userId,
						limit: 5,
						type
					})
					.catch(() => {})
					.then(() => {
						this.fetchTransactionHistoryLoading = false;
					});
			}
		}
	}
};
</script>
